import { z } from 'zod'

export const FeatureFlagItemDTO = z.object({
  name: z.string(),
  enabled: z.boolean()
})

export const FeatureFlagsResponseDTO = z.object({
  data: z.object({
    feature_flags: z.array(FeatureFlagItemDTO)
  })
})

export type FeatureFlagItem = z.infer<typeof FeatureFlagItemDTO>
